module.exports = __webpack_public_path__ + "img/placeholder.82a33a43.png";